import anime from 'animejs';
import _ from 'lodash';
import React, { memo, useEffect, useRef, useState } from 'react';
import FadeIn from 'react-fade-in';
import { BsChevronRight } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseSelectedColor } from '../../utils/manager/layout-manager';
import { wait } from '../../utils/wait';
import { ItemDescription } from './item-description';
import { ItemPrices } from './item-prices';
import { ItemTitle } from './item-title';
import { Options } from './options';

function ItemPrivate({ data, category, setUpdating, onPress }) {
  const { showingModal, menuLayout } = useStorage();
  const [selected, setSelected] = useState(false);
  const classes = useStyles({ selected, layout: menuLayout });
  const ref = useRef();

  // const cellClass = `cell-${item.id}`;
  // const animation = 'animate__animated animate__fadeInUp';

  useEffect(() => {
    if (menuLayout != null) {
      const animate = async () => {
        const opacity = selected ? 1 : 0;

        anime({
          targets: ref.current,
          backgroundColor: [
            ref.current.style.backgroundColor,
            parseSelectedColor(menuLayout, opacity),
          ],
          outlineColor: [
            ref.current.style.backgroundColor,
            parseSelectedColor(menuLayout, opacity),
          ],
          easing: 'linear',
          duration: selected ? 50 : 150,
          // direction: selected ? 'reverse' : 'normal',
          // complete: (props) => setSelected(false),
          delay: selected ? 0 : 150,
        });
      };

      animate();
    }
  }, [menuLayout, selected]);

  useEffect(() => {
    if (showingModal === false && selected === true) {
      setSelected(false);
    }
  }, [showingModal]);

  const onClick = async () => {
    setSelected(true);
    setUpdating(false);

    await wait(150);
    if (_.isFunction(onPress)) await onPress(category, data);

    setUpdating(true);
    setSelected(false);
  };

  return (
    <FadeIn>
      <div
        ref={ref}
        className={classes.container}
        onClick={onClick}
        aria-hidden
      >
        <div className={classes.cell}>
          <div className={classes.info}>
            <ItemTitle item={data} />
            <ItemDescription item={data} />

            <Options
              values={_.head(data.option_groups)?.options?.filter(
                (option) => !option.blocked
              )}
              visible={data.show_options}
            />
          </div>
          <ItemPrices item={data} category={category} />
          <div className={classes.chevron}>
            <BsChevronRight />
          </div>
        </div>
      </div>
    </FadeIn>
  );
}

const useStyles = createUseStyles({
  container: {
    cursor: 'pointer',
    backgroundColor: 'transparent',
    outlineColor: 'transparent',
    // backgroundColor: ({ selected, layout }) => selected ? parseSelectedColor(layout) : 'transparent',
    // outlineColor: ({ selected, layout }) => selected ? parseSelectedColor(layout) : 'transparent',
    outlineWidth: 1,
    outlineStyle: 'solid',
  },
  cell: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    paddingLeft: layoutDefaults.mainHorizontalMargin,
    paddingRight: layoutDefaults.mainHorizontalMargin,
    paddingTop: layoutDefaults.verticalMargin,
    paddingBottom: layoutDefaults.verticalMargin,

    // opacity: 0,
    // border: '1px solid blue',
  },
  info: {
    flexGrow: 1,
    // border: '1px solid red',
  },
  chevron: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    opacity: 0.6,

    marginLeft: -4,
    marginRight: -4,

    // border: '1px solid red',
  },
});

const Item = memo(ItemPrivate, _.isEqual);
export { Item };
